module.exports = __webpack_public_path__ + "img/submit_music.27478e36.svg";